import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import StepBackButton from '../../components/atoms/StepBackButton';
import GochiKidMenuTable from '../organisms/GochiKidMenuTable';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getGochiKidMenus,
  getOrderGochiMenus,
  downloadMenu
} from '../../actions/GochiMenus';
import { getAccounts } from '../../actions/Accounts';
import { getShops, getShopMenuViewOrder } from '../../actions/Shop';
import {
  getOptionShops,
  getMenuGenreOption,
  getMenuSituationOption,
  getMenuUserTargetOption
} from '../../actions/Options';

const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      identityStatuses: state.identities.statuses,
      showHides: state.gochiMenus.showHide,
      menuChildTypes: state.gochiMenus.menuChildType,
      menuGenre: state.options.listMenuGenre,
      menuSituation: state.options.listMenuSituation,
      menuUserTarget: state.options.listMenuUserTarget
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiKidMenus,
          getOrderGochiMenus,
          downloadMenu,
          getAccounts,
          getShops,
          getOptionShops,
          getShopMenuViewOrder,
          getMenuGenreOption,
          getMenuSituationOption,
          getMenuUserTargetOption
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('openViewOrderCustom', 'updateOpenViewOrderCustom', false),
  withState('openViewOrderCustomList', 'updateOpenViewOrderCustomList', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('orderMenuShopId', 'setOrderMenuShopId', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopId', 'setShopId', null),
  withState('menuName', 'setMenuName', ''),
  withState('menuId', 'setMenuId', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('identityStatus', 'setIdentityStatus', ''),
  withState('showHide', 'setShowHide', ''),
  withState('menuChildType', 'setMenuChildType', ''),
  withState('menuSystemFlag', 'setMenuSystemFlag', ''),
  withState('menuGenre', 'setMenuGenre', []),
  withState('menuSituation', 'setMenuSituation', []),
  withState('menuUserTarget', 'setMenuUserTarget', []),
  withState('groupId', 'setGroupId', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        gochiKidFlag: 0,
        groupId: props.groupId,
        shopName: props.shopName,
        menuName: props.menuName,
        shopId: props.shopId,
        menuId: props.menuId,
        identityStatus: props.identityStatus,
        showHide: props.showHide,
        menuChildType: props.menuChildType,
        menuSystemFlag: props.menuSystemFlag,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getGochiKidMenus(searchKey)
        .then(data => {
          props.checkSession(data);
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        const searchShopId = queryString.parse(this.props.location.search)
          .shopId
          ? queryString.parse(this.props.location.search).shopId
          : '';
        if (searchShopId && searchShopId > 0) {
          this.props.setShopId(Number(searchShopId));
        } else {
          this.props.setShopId(null);
        }
        if (data.payload.role === 'SHOP') {
          this.props.actions
            .getGochiKidMenus({
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(menuData => this.props.checkSession(menuData));
          this.props.updateOpenTable(true);
        } else if (searchShopId) {
          await this.props.actions
            .getGochiKidMenus({
              shopId: searchShopId,
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(async menuData => {
              this.props.checkSession(menuData);
              if (menuData.payload.menus.length) {
                this.props.setShopName(menuData.payload.menus[0].shopName);
              } else {
                await this.props.actions
                  .getShops({ shopId: searchShopId })
                  .then(shopData => {
                    this.props.checkSession(shopData);
                    this.props.setShopName(shopData.payload.shops[0].shopName);
                  });
              }
            });
          this.props.updateOpenTable(true);
        }
      });
      this.props.handleChangePage(null, 1, 100);
      this.props.updateOpenTable(true);
      this.props.actions.getMenuGenreOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuGenre(data.payload);
      });
      this.props.actions.getMenuSituationOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuSituation(data.payload);
      });
      this.props.actions.getMenuUserTargetOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuUserTarget(data.payload);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleRedirect,
    handleChangePage,
    account,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    shopId,
    setShopId,
    shopName,
    setShopName,
    menuName,
    setMenuName,
    menuId,
    setMenuId,
    resultMessage,
    setResultMessage,
    page,
    identityStatus,
    showHide,
    menuChildType,
    menuGenre,
    menuSituation,
    menuUserTarget,
    menuSystemFlag,
    groupId,
    setGroupId
  }) => {
    const isChildShop =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      ((account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0) ||
        account.childShopFlag === 1);
    const isChildGroup =
      typeof account !== 'undefined' &&
      account.role === 'GROUP' &&
      (account.groupType !== null &&
        account.groupType.toUpperCase() === 'OTHERS');
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const roles = {
      isChildShop,
      isChildGroup,
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      groupId,
      shopName,
      menuName,
      shopId,
      menuId,
      identityStatus,
      showHide,
      menuChildType,
      menuSystemFlag,
      page,
      limit: limitNum
    };
    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const backAction = () => handleRedirect('/release_step');

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            こどもごちめしメニュー登録
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="店舗名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopName}
                  onChange={e => {
                    setShopName(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="店舗ID"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopId}
                  onChange={e => {
                    setShopId(e.target.value);
                  }}
                />
              )}
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="グループID"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={groupId}
                  onChange={e => {
                    setGroupId(e.target.value);
                  }}
                />
              )}
            </div>
            <div>
              <TextField
                label="メニュー名"
                placeholder="部分一致"
                type="search"
                className={[classes.textField, classes.textInput100]}
                margin="normal"
                value={menuName}
                onChange={e => {
                  setMenuName(e.target.value);
                }}
              />
              <TextField
                label="メニューID"
                placeholder="部分一致"
                type="search"
                className={[classes.textField, classes.textInput100]}
                margin="normal"
                value={menuId}
                onChange={e => {
                  setMenuId(e.target.value);
                }}
              />
            </div>
            <div>
              <SearchButton onClickAction={searchAction} />
            </div>
          </div>
          {openTable && (
            <GochiKidMenuTable
              searchKey={searchKey}
              roles={roles}
              progress={progress}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
              menuGenre={menuGenre}
              menuSituation={menuSituation}
              menuUserTarget={menuUserTarget}
              isAddGochiKidMenu
            />
          )}
          {isShop && !isReleased && (
            <div>
              <StepBackButton onClickAction={backAction} />
            </div>
          )}
          <ProgressDialog openProgress={openProgress} loading={loading} />
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
